"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroPropagateXconNameRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class AllegroPropagateXconNameRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        for (const [, nets] of group.getNets()) {
            for (const net of nets) {
                const name = net.name.valueOf();
                if (name.length > 0 && !name.startsWith('__UNNAMED_NET_')) {
                    return name;
                }
            }
        }
        return undefined;
    }
}
exports.AllegroPropagateXconNameRule = AllegroPropagateXconNameRule;
//# sourceMappingURL=AllegroPropagateXconNameRule.js.map